module.exports = __webpack_public_path__ + "img/lake-village.aeae8bdc.svg";